import actions from "./actions";
import mutations from "./mutations";
import { pagination, sorting } from "@/store/helpers";

export default {
  namespaced: true,
  state: {
    query: "",
    statusFilter: "",
    recipients: [],
    camera: {},
    camerasListLoading: false,
    cameraStreamsUrls: {},
    cameras: {
      ...pagination,
      ...sorting,
      parameters: [],
    },
    config: {},
    model: {},
    agent_status: ""
  },
  actions,
  getters: {
    getQuery(state) {
      return state.query;
    },
    getStatusFilter(state) {
      return state.statusFilter;
    },
  },
  mutations,
};
